import ApplePay from 'features/moveMoney/screens/ApplePay/ApplePay';
import React from 'react';

export default function Page() {
  return <ApplePay />;
}
